module.exports = __webpack_public_path__ + "media/Video 67.caa7a8d0.mp4";